import { Injectable } from '@angular/core';
import { ApiService } from 'app/main/shared/services/api.service';
import { LocalAccountService } from '../shared/services/localAccount.service';
import { AuthService } from '../shared/services/auth.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private api: ApiService,
    private localAccountService: LocalAccountService,
    private auth: AuthService
  ) {

  }

  private dataSource = new BehaviorSubject<any>({ emergencyNotifications: null });
  onEmergencyNotificationsValueChange = this.dataSource.asObservable();

  private dataSource2 = new BehaviorSubject<any>({ emergencyNotifications: null });
  onEmergencyNotificationsValueChange2 = this.dataSource2.asObservable();

  private dataSource3 = new BehaviorSubject<any>({ emergencyNotifications: null });
  onEmergencyNotificationsValueChange3 = this.dataSource3.asObservable();

  /* NUOVE API */
  async getNotifications() {
    return this.api.getRequestPromise(`retrieveNotifiche`);
  }

  /* http://localhost:8200/exellente/bo/notification/{notificaID}/setNotificationToRead */
  async setRead(notificationId) {
    return this.api.putRequestPromise(`notification/${notificationId}/setNotificationToRead`, null);
  }



  /* VECCHIE API */
  countEmergencyNotfications(statuses?) {
    if (this.auth.loggedIn()) {
      // if (this.localAccountService.isOperator()) {
      let internalStatuses = '';
      if (statuses) {
        internalStatuses = statuses;
      }
      return this.api.getRequest(`emergency/count?statuses=${internalStatuses}`);
      // }
    }
  }

  getEmergencyNotfications(statuses?) {
    let internalStatuses = '';
    if (statuses) {
      internalStatuses = statuses;
    }
    return this.api.getRequest(`emergency?statuses=${internalStatuses}`);
  }

  getHistoryEmergencyNotfications(statuses?) {
    let internalStatuses = '';
    if (statuses) {
      internalStatuses = statuses;
    }
    return this.api.getRequest(`emergency/history?statuses=${internalStatuses}`);
  }

  closeEmergency(emergencyId) {
    return this.api.putRequest(`emergency/${emergencyId}/close`, null);
  }

  openEmergency(emergencyId) {
    return this.api.putRequest(`emergency/${emergencyId}/open`, null);
  }

  processingEmergency(emergencyId) {
    return this.api.putRequest(`emergency/${emergencyId}/processing`, null);
  }

  processingEmergency2(emergencyId, body) {
    return this.api.putRequest(`bo/emergency/${emergencyId}/processing`, body);
  }

  closeEmergencyByPatientId(patientId) {
    return this.api.putRequest(`emergency/${patientId}/closebypatientid`, null);
  }



  updateEmergencyNotificationsValue(emergencyNotifications) {
    // if (emergencyNotifications === false) {
    //   this.dataSource.unsubscribe();
    // } else {
    //   this.dataSource.next(emergencyNotifications);
    // }
    this.dataSource.next(emergencyNotifications);
  }

  updateEmergencyNotificationsValue2(emergencyNotifications) {
    // if (emergencyNotifications === false) {
    //   this.dataSource2.unsubscribe();
    // } else {
    //   this.dataSource2.next(emergencyNotifications);
    // }
    this.dataSource2.next(emergencyNotifications);
  }

  updateEmergencyNotificationsValue3(emergencyNotifications) {
    // if (emergencyNotifications === false) {
    //   this.dataSource3.unsubscribe();
    // } else {
    //   this.dataSource3.next(emergencyNotifications);
    // }
    this.dataSource3.next(emergencyNotifications);
  }

}
